// local

export class Envelope {
    public MinX: number = Number.MIN_VALUE;
    public MinY: number = Number.MIN_VALUE;
    public MaxX: number = Number.MAX_VALUE;
    public MaxY: number = Number.MAX_VALUE;
  
    public constructor(minx: number, miny: number, maxx: number, maxy: number) {
      this.MinX = minx;
      this.MinY = miny;
      this.MaxX = maxx;
      this.MaxY = maxy;
    }
  }
  export class Coordinate {
    public X: number;
    public Y: number;
    public Z: number;
  
    public constructor(x: number, y: number, z: number = 0) {
      this.X = x;
      this.Y = y;
      this.Z = z;
    }
  }
  export class Rectangle {
    public X: number;
    public Y: number;
    public Width: number;
    public Height: number;
  
    public get Left(): number { return this.X; }
    public get Right(): number { return this.X + this.Width; }
  
    public get Bottom(): number { return this.Y + this.Height; }
    public get Top(): number { return this.Y; }
  
    public constructor(x: number, y: number, width: number, height: number) {
      this.X = x;
      this.Y = y;
      this.Width = width;
      this.Height = height;
    }
  }
  
  
  